import * as React from 'react'
import { BankOutlined, SafetyCertificateOutlined } from '@ant-design/icons'
import { Button, Input, List, Modal, PageHeader, Row, Select, Steps } from 'antd'
import { Menu, Space, Typography, Tooltip, Spin } from 'antd'
import { DataNode } from 'antd/lib/tree'
import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import { AccessoCcModel, CatDataNode, ContiCorrentiModel, ContoCorrenteModel } from '../../models/ConfigurazioneModels'
import { ModalCategoria, OperationType } from './ModalCategoria'
import { EsempioCategorie } from './EsempioCategorie'
import Operation from 'antd/lib/transfer/operation'
import Search from 'antd/lib/input/Search'
import { TTAvatar } from '../shared/TTAvatar'
import { ModelBase } from '../../models/ModelBase'
import { IYapilyService } from '../../services/YapilyService'
import { ScaMethod, YapilyFlowModel } from '../../models/YapilyModels'
import { RouteComponentProps, withRouter } from 'react-router'
import { TTFormItem } from '../shared/TTFormItem'
import Password from 'antd/lib/input/Password'
import { TTSelect } from '../shared/TTSelect'
const { Text } = Typography
const { Step } = Steps;

class PageYapilyEmbeddedFlowState extends YapilyFlowModel {
    CurrentIndex: number = 0
}

interface YapilyPropos {
    id: string

}

export class PageYapilyEmbeddedFlowComp extends React.Component<RouteComponentProps<YapilyPropos>, PageYapilyEmbeddedFlowState> {

    service: IYapilyService
    steps: any
    selMethod:string

    constructor(props) {
        super(props)
        this.state = new PageYapilyEmbeddedFlowState()
        //const [current, setCurrent] = React.useState(0);
        this.service = container.get(SERVICE_IDENTIFIER.YAPILY_SERVICE)
        this.steps = [
            {
                title: 'Dati identificativi',
            },
            {
                title: 'Metodo di autenticazione forte',
            },
            {
                title: 'Codice One Time Password',
            },
            {
                title: 'Completa autenticazione',
            },
        ];
        //this.current = 0;
        // const id = this.props.match.params.id
    }

    async componentDidMount() {
        this.load()
    }

    load = () => {
        let ccId = this.props.match.params.id
        this.setState({
            IdContoCorrente: ccId, CurrentIndex: 0
        })
    }

    onClick = async () => {
        var x = await this.service.StartAuthFlow(this.state)
        if (x.IsValid == true) {
            window.location.href = x.Code
        }
    }

    next = async (index: number = 1) => {
        let valid = false
        let status = ""
        if (this.state.CurrentIndex == 0) {
            let res = await this.service.StartAuthEmbeddedFlow(this.state)
            valid = res.IsValid
            if (res.IsValid == true) {
                status = res.YapilyStatus
                this.setState({ ...this.state, Id: res.Id })
                if (res.YapilyStatus != null) {
                    index = res.YapilyStatus == "AWAITING_SCA_METHOD" ? 1 : 2;
                    this.setState({ ...this.state, ScaMethods: res.ScaMethods, YapilyStatus: res.YapilyStatus });
                }
            }
        }
        // STEP PER LA SCELTA DELLO SCA METHOD
        if (this.state.CurrentIndex == 1) {
            let selMet: ScaMethod = this.state.ScaMethods.find(c => c.id = this.selMethod)
            let model = new YapilyFlowModel()
            model = { ...this.state }
            model.SelectedMethod = selMet
            let res = await this.service.UpdateAuthEmbeddedFlowScaMethodChoise(model)
            valid = res.IsValid
            if (valid) {
                this.setState({ ...this.state, SelectedMethod: selMet })
                status = res.YapilyStatus
            }
        }

        // STEP PER L'INSERIMENTO DELLO SCA CODE
        if (this.state.CurrentIndex == 2) {
            let res = await this.service.UpdateAuthEmbeddedFlowScaCode(this.state)
            valid = res.IsValid

            if (!valid && res.Notifies[0].Message != "Codice OTP obbligatorio") {
                let model = new PageYapilyEmbeddedFlowState()
                model.BancaPassword = null
                model.BancaUser = null
                this.state = model
                this.setState({...this.state})
                this.load()
            }

            status = res.YapilyStatus
        }
        if (!valid) return;

        if (status == "AUTHORIZED") {
            let res = await this.service.GetConsent(this.state)
            if (!res.IsValid) return
            window.location.href = "/Configurazione/AccessoCc/"
            return;
        }
        if (status == "AWAITING_DECOUPLED_AUTHORIZATION")
            index = this.state.CurrentIndex == 0 ? 3 : 2 // mi permette di accedere all'ultimo step
        var next = this.state.CurrentIndex + index;
        this.setState({ ...this.state, CurrentIndex: next });
    }

    done = async () => {
        let res = await this.service.GetConsent(this.state)
        if (res.IsValid)
            window.location.href = "/Configurazione/AccessoCc/"
    }

    renderScaMethods = (source: Array<ScaMethod>) => {
        if (source == null) return
        let items = source.map((it) =>
            <Select.Option key={it.id} value={it.id}>{it.description} - {it.type}</Select.Option>
        )

        return items
    }

    render() {
        return (
            <PageHeader title="Wizard"  >
                <p>
                    Questi pochi e semplici passi ti permetteranno di autenticarti sulla tua Banca e potremo così richiedere il permesso di <b>accedere in sola lettura</b> al tuo conto corrente.<br />
                    I tuoi dati <b>non vengono salvati nei nostri sistemi</b> e vengono <b>inviati in modo sicuro</b> alla tua banca per poter completare la procedura di autenticazione con le modalità previste dalla banca stessa.<br />
                </p>
                <Steps current={this.state.CurrentIndex}>
                    {this.steps.map((item) => (
                        <Step key={item.title} title={item.title} />
                    ))}
                </Steps>
                {
                    this.state.CurrentIndex === 0 && (
                        <div className="steps-content">
                            <br />
                            <p>
                                Inserisci qui sotto i dati identificativi della tua Banca e premi "Avanti"</p>
                            <br />
                            <TTFormItem label="Il tuo codice utente" required={true}>
                                <Input value={this.state.BancaUser} onChange={e => this.setState({ ...this.state, BancaUser: e.target.value as string })} />
                            </TTFormItem>
                            <TTFormItem label="La tua password" required={true}>
                                <Input value={this.state.BancaPassword} type="password" onChange={e => this.setState({ ...this.state, BancaPassword: e.target.value as string })} />
                            </TTFormItem>
                        </div>
                    )
                }
                {
                    this.state.CurrentIndex === 1 && (
                        <div className="steps-content">
                            <br />
                            <p>La tua banca prevede diversi metodi per l'autenticazione forte (a 3 fattori); scegli dalla tendina il metodo che preferisci e premi "Avanti"</p>
                            <br />
                            <TTFormItem label="Metodo OTP" required={true}>
                                <TTSelect size="small" value={this.selMethod} onChange={e => this.selMethod = e as string} showSearch allowClear>
                                    {this.renderScaMethods(this.state.ScaMethods)}
                                </TTSelect>
                            </TTFormItem>
                        </div>)
                }
                {
                    this.state.CurrentIndex === 2 && (<div className="steps-content">
                        <br />
                        <p>La tua Banca ti ha inviato un codice OTP (One Time Password) necessario per completare l'autenticazione.
                            <br />Inserisci il valore di questo codice nell'apposito campo qui sotto e premi "Avanti"</p>
                        <br />
                        <TTFormItem label="Codice OTP ricevuto" required={true}>
                            <Input value={this.state.ScaCode} onChange={e => this.setState({ ...this.state, ScaCode: e.target.value as string })} />
                        </TTFormItem>
                    </div>)
                }
                {
                    this.state.CurrentIndex === 3 && (<div className="steps-content">
                        <br />
                        <p>La tua Banca ti ha inviato una richiesta di autorizzazione.<br />Dai la tua autorizzazione e premi "Conferma e completa procedura"</p>
                        <br />
                    </div>)
                }
                <div className="steps-action">
                    {this.state.CurrentIndex < this.steps.length - 1 && (
                        <Button type="primary" onClick={() => this.next()}>
                            Avanti
                        </Button>
                    )}
                    {this.state.CurrentIndex === this.steps.length - 1 && (
                        <Button type="primary" onClick={() => this.done()}>
                            Conferma e completa procedura
                        </Button>
                    )}
                </div>
            </PageHeader>
        )
    }
}

export const PageYapilyEmbeddedFlow = withRouter(PageYapilyEmbeddedFlowComp)